export const getInsurancesFrag = `
    insuredFrom
    insuredTo
    insuranceType
`;

export const getBilledWorksFrag = `
    id
`;
